import {useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { OrderContainer } from './order.container';
import { BasePageStyles } from '../../hooks/styles';
import { Container } from '@mui/material';
const Order = () => {
  const classes = BasePageStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <OrderContainer />
      </Container>
    </BasePage>
  )
}

export default Order;